import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const GoRegisterPage = lazy(() => import('../pages/go-register/page'));
const GoPage = lazy(() => import('../pages/go/page'));
const SlotCrackerLP = lazy(() => import('../pages/slot/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/slot',
    element: <SlotCrackerLP />,
  },
  {
    path: '/go-register',
    element: <GoRegisterPage />,
  },
  {
    path: '/go',
    element: <GoPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
